import { Component, EventEmitter, HostListener, Input, model, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { IconSquarePenComponent } from '../icon-square-pen/icon-square-pen.component';

@Component({
  selector: 'app-dropdown',
  standalone: true,
  imports: [IconSquarePenComponent, LoadingSpinnerComponent, CommonModule],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.css'
})
export class DropdownComponent {

  isDropdownOpen = false;

  optionItems = model<any[]>([]);
  @Input() data: any | undefined;
  @Output() dataSelected = new EventEmitter<any>();

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const isInsideDropdown = target.closest('.dropdown-container');

    if (!isInsideDropdown) {
      this.isDropdownOpen = false;
    }
  }

  getDataSelected(callback: Function) {
    if (this.data !== undefined) {
      this.dataSelected.emit(this.data);
    }
    callback();
    this.isDropdownOpen = false;
  }

}
